import {manager_get, manager_login} from "../modules/nite_api";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";

export default {
    namespaced: true,
    state: {
        token: null,
        refresh_token: null,
        manager: null,
        error_status: null,
        loading: false


    },

    getters: {

        authenticated(state) {

            return !(state.token == null || state.manager == null);
        },

        manager(state) {

            return state.manager;

        },



        loading(state) {

            return state.loading;

        }


    },

    mutations: {

        SET_TOKEN(state, token) {
            state.token = token;
        },

        SET_REFRESH_TOKEN(state, refresh_token) {
            state.token = refresh_token;
        },

        SET_USER(state, manager) {
            state.manager = manager;

        },
        SET_LOADING(state, loading) {
            state.loading = loading;

        },






    },

    actions: {
        async sign_in({dispatch}, credentials) {
            try {
                let response = await manager_login(credentials);

                // Success
                console.log(response);
                this.error_status = response.status;
                return dispatch('attempt', response.data);
            } catch (error) {
                // Error
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                    this.error_status = error.response.status;


                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error);
            } finally {
                if (this.error_status !== 200) {
                    this.loading = false;
                    switch (this.error_status) {


                        case 400:
                            await Swal.fire({
                                    title: 'Oops',
                                    text: 'Some field is missing or isn\'t correct. Please make the corrections and try again!',
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                }
                            );
                            break;
                        case 401:
                            await Swal.fire({
                                title: 'Error',
                                text: 'Username or Password Invalid',
                                icon: 'error',
                                confirmButtonText: 'OK'
                            });
                            break;

                        case 404:
                            await Swal.fire({
                                title: 'Oops',
                                text: 'User doesn\'t exist!'
                                , icon: 'error', confirmButtonText: 'OK'
                            });
                            break;
                        case 500:
                            await Swal.fire({
                                title: 'Error',
                                text: 'Something went wrong with the request. Please try again later!'
                                , icon: 'error', confirmButtonText: 'OK'
                            });
                            break;
                        default:
                            break;
                    }
                }


            }

            return Promise.reject({})

        },
        async attempt({commit, state}, credentials) {

            if (credentials && credentials.token) {

                commit('SET_TOKEN', credentials.token);
                commit('SET_REFRESH_TOKEN', credentials.refresh_token);

            }

            if (!state.token) {
                return;

            }


            let decoded = jwt_decode(credentials.token);

            console.log(decoded);

            try {
                const response = await manager_get()
                commit('SET_USER', response.data);
                // Success
                console.log(response);

            } catch (error) {
                // Error
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                    commit('SET_USER', null)
                    commit('SET_TOKEN', null)
                    commit('SET_REFRESH_TOKEN', null)

                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error);
            }

        }


    }

}